import {InnerTabs, MyBreadcrumb, MyText} from "../../components";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {generatePath, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import {selectStore} from "../../store/selector";
import {Card, Col, Flex, List, Row, Select} from "antd";
import {getExamAction} from "../../store/pages/exam/actions";
import {UserOutlined} from "@ant-design/icons";
import {ROUTE_PATH} from "../../constants";
import dayjs from "dayjs";

const semesters = [
  {
    key: '1',
    label: '1 семестр',
  },
  {
    key: '2',
    label: '2 семестр',
  },
  {
    key: 'final',
    label: 'Итоговые',
  }
]

export const Exam = () => {
  const {t} = useTranslation("common")
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    exam: {exam: examState},
  }: RootState = useSelector(selectStore)

  const [currentClass, setCurrentClass] = useState()
  const [currentSemester, setCurrentSemester] = useState(semesters[0].key)

  useEffect(() => {
    let params = {
      ...(currentClass ? {class: currentClass} : {}),
      semester: currentSemester
    }
    getExam(params)
  }, [])

  const getColor = (mark: number) => {
    if (mark >= 0 && mark <= 33) {
      return '#FFB800'
    } else if (mark >= 33 && mark <= 66) {
      return '#109CF1'
    } else {
      return '#4EAF51'
    }
  }

  const handleNavigate = (id: any) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.EXAM_PLAN, {lessonId: id}),
    }

    navigate(path);
  }

  const array = semesters?.map(item => ({
    key: item.key,
    label: item.label,
    children: (
      <Row>
        <Col span={24}>
          <List
            grid={{
              gutter: [16, 16],
              column: 3
            }}
            pagination={false}
            loading={examState?.loading}
            dataSource={examState?.data?.exams}
            style={{padding: 12}}
            renderItem={(item: any, index: any) => (
              <List.Item style={{marginBottom: 0, cursor: 'pointer'}} onClick={() => handleNavigate(item?.id)}>
                <Card title={
                  <Row align='middle' justify='space-between'>
                    <Col>
                      <MyText size={12} weight={700} color='#DA192C' style={{textTransform: 'uppercase'}}>{item?.theme}</MyText>
                    </Col>

                    <Col>
                      <MyText size={14} weight={400} color='rgb(235 100 113)'>{dayjs(item?.date).format('DD.MM.YYYY')}</MyText>
                    </Col>
                  </Row>
                } styles={
                  {
                    header: {
                      padding: '0 12px',
                      minHeight: 'auto',
                      backgroundColor: '#FFE3E1'
                    },
                    body: {padding: 12}
                  }
                }>
                  <Row>
                    <Col span={24}>
                      <MyText size={16} weight={500} color='#1C1C1E'>
                        {item?.subject}
                      </MyText>
                    </Col>

                    <Col span={24}>
                      <MyText size={14} weight={400} color='#49494D'>
                        {item?.module}
                      </MyText>
                    </Col>

                    <Col span={24}>
                     <Row justify='space-between' align='middle'>
                       <Col>
                         <Row align='middle' gutter={[8, 8]}>
                           <Col>
                             <UserOutlined />
                           </Col>
                           <Col>
                             <MyText size={14} weight={400} color='#49494D'>
                               {item?.teacher}
                             </MyText>
                           </Col>
                         </Row>
                       </Col>

                       <Col>
                         <Flex style={{
                           width: 40,
                           height: 40,
                           backgroundColor: item?.mark ? getColor(item?.mark) : 'transparent',
                           borderRadius: 8
                         }} align='center' justify='center'>
                           <MyText size={24} weight={500} color='#fff'>
                             {item?.mark}
                           </MyText>
                         </Flex>
                       </Col>
                     </Row>
                    </Col>
                  </Row>
                </Card>
              </List.Item>
            )}
          />
        </Col>
      </Row>
    ),
  }))

  const handleChangeSemester = (key: any) => {
    setCurrentSemester(key)

    let params = {
      ...(currentClass ? {class: currentClass} : {}),
      semester: key
    }
    getExam(params)
  }

  const handleChangeClass = (key: any) => {
    setCurrentClass(key)

    let params = {
      class: key,
      semester: currentSemester
    }
    getExam(params)
  }

  const getExam = (params: any) => {
    dispatch(getExamAction(params))
  }

  return (
    <>
      <MyBreadcrumb title={'Экзамены'} extra={(
        <Row gutter={[16, 16]} align='middle'>
          <Col>
            <MyText>
              Курс
            </MyText>
          </Col>
          <Col>
            <Select options={examState?.data?.classes?.map((item: any) => ({
              key: `${item}`,
              label: `${item} курс`,
              value: item
            }))} style={{width: 100}} onChange={(value, option) => handleChangeClass(value)}
                    value={currentClass} loading={examState?.loading} disabled={!examState?.success}/>
          </Col>
        </Row>
      )}/>
      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
              <InnerTabs items={array} activeKey={currentSemester}
                         onChange={(activeKey) => handleChangeSemester(activeKey)}/>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}